import React, { useState } from "react";
import { Button, Stack, Tab, Tabs } from "@mui/material";
import {
  DataGrid,
  GridFooter,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { AiFillEye } from "react-icons/ai";
import { BsTrash2 } from "react-icons/bs";
import { IoCreateOutline } from "react-icons/io5";
import { TbBookUpload } from "react-icons/tb";
function CustomToolbar(props) {
  const { createNewUserRole } = props;
  return (
    <GridToolbarContainer
      style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}
    >
      <div className="d-flex gap-1" style={{ flex: 1 }}>
        <GridToolbarFilterButton />
        <GridToolbarColumnsButton />
        <GridToolbarExport />
      </div>
      <GridToolbarQuickFilter debounceMs={250} style={{ flex: 1 }} />
      <Button
        variant="contained"
        color="success"
        onClick={createNewUserRole}
        endIcon={<IoCreateOutline />}
      >
        Create
      </Button>
    </GridToolbarContainer>
  );
}

function OverlayMessageComponent({ search, isFetched }) {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      {isFetched
        ? search
          ? "No Search Results Found"
          : "No Users Found for Role"
        : "Loading Users"}
    </Stack>
  );
}

const ManageUsers = () => {
  const [role, setRole] = useState("ROLE_CITIZEN"); // State to control the active tab

  // Sample user data
  const userList = [
    {
      id: 1,
      firstName: "John",
      lastName: "Doe",
      email: "john.doe@example.com",
      mobileNo: "123-456-7890",
      division: "Division A",
      wardNo: "Ward 1",
      authorities: [{ authority: "Students" }],
    },
  ];

  const tableColumns = [
    {
      field: "firstName",
      headerName: "First Name",
      flex: 4,
      renderCell: (params) => {
        return params.row.firstName + " " + params.row.lastName;
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 6,
    },
    {
      field: "mobileNo",
      headerName: "Mobile No",
      flex: 4,
    },
    {
      field: "Address",
      headerName: "Address",
      flex: 4,
      renderCell: (params) => {
        return params.row.wardNo + ", " + params.row.division;
      },
    },
    {
      field: "view",
      headerName: "View",
      flex: 2,
      filterable: false,
      sortable: false,
      hideable: false,
      printable: false,
      renderCell: (params) => {
        return (
          <Button
            onClick={() => {
              // Handle view action here
            }}
            fullWidth
            color="primary"
            endIcon={<AiFillEye />}
          >
            View
          </Button>
        );
      },
    },
    {
      field: "update",
      headerName: "Update",
      flex: 2,
      filterable: false,
      sortable: false,
      hideable: false,
      renderCell: (params) => {
        return (
          <Button
            onClick={() => {
              // Handle update action here
            }}
            fullWidth
            color="info"
            endIcon={<TbBookUpload />}
          >
            Update
          </Button>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 2,
      filterable: false,
      sortable: false,
      hideable: false,
      renderCell: (params) => {
        return (
          <Button
            onClick={() => {
              // Handle delete action here
            }}
            fullWidth
            color="error"
            endIcon={<BsTrash2 />}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <div
        className="container py-2 gap-2 d-flex flex-column"
        style={{ height: "90vh" }}
      >
        <div className="border d-flex flex-column" style={{ flex: 10 }}>
          <Tabs
            value={role}
            onChange={(e, newRole) => setRole(newRole)} // Handle tab change
            fill
            justify
            variant="pills"
            style={{ flex: 1 }}
          >
            <Tab label="Students" value="ROLE_CITIZEN" />
            <Tab label="Industry" value="ROLE_ADMIN" />
            <Tab label="Teacher" value="ROLE_DIVISIONAL" />
            <Tab label="Merchant" value="ROLE_SUPER_ADMIN" />
          </Tabs>
          <div className="px-3" style={{ flex: 10, overflow: "scroll" }}>
            <DataGrid
              disableRowSelectionOnClick
              disableColumnMenu
              getRowId={(item) => item.id}
              sx={{
                "& .MuiDataGrid-virtualScroller": { overflow: "hidden " },
              }}
              rows={userList}
              columns={tableColumns}
              slots={{
                footer: GridFooter,
                toolbar: CustomToolbar,
                noRowsOverlay: OverlayMessageComponent,
                noResultsOverlay: OverlayMessageComponent,
              }}
              slotProps={{
                toolbar: {
                  createNewUserRole: () => {
                    // Handle create action here
                  },
                },
                noResultsOverlay: {
                  isFetched: true,
                  search: true,
                },
                noRowsOverlay: {
                  isFetched: true,
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageUsers;
